import { TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, useController } from 'react-hook-form';

export interface EmailFieldProps {
  control: Control<any>;
  size?: 'small' | 'medium';
}

const EmailField = ({ control, size = 'medium' }: EmailFieldProps) => {
  useController({
    control,
    name: 'email',
    rules: {
      required: 'Please enter a valid email address',
      pattern: {
        message: 'Please enter a valid email address.',
        value:
          // eslint-disable-next-line no-useless-escape
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      },
    },
  });

  return (
    <Controller
      control={control}
      name="email"
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          inputProps={{
            inputMode: 'email',
          }}
          autoComplete="off"
          error={!!error}
          helperText={error?.message}
          label="Email"
          placeholder="Enter your email address"
          required
          size={size}
        />
      )}
    />
  );
};

export default EmailField;
